<div class="reports">
  <div class="report-header">
    <h2>Gemeldete Inhalte</h2>
    <div class="report-header-searchbar">
      <app-searchbar
        (searchTermChange)="onSearchTerms($event)"
        id="searchbar-report"
        class="searchbar"
        placeholder="Schnellsuche"
        [dataTestId]="testIds.reportSearch"></app-searchbar>
    </div>
  </div>

  <div class="filter-row" [attr.data-testid]="testIds.filterRow">
    <span class="filter-label" [attr.data-testid]="testIds.filterLabel">Filter</span>
    <div class="filter-controls" [attr.data-testid]="testIds.filterControls">
      <mat-form-field appearance="outline" class="custom-filter-field reports-filter-width">
        <mat-select
          placeholder="Filter Reports"
          [attr.data-testid]="testIds.filterSelection"
          (selectionChange)="setFilter($event)">
          <mat-option [attr.data-testid]="testIds.userIdOption" value="user_id">TI-M Adresse Meldender</mat-option>
        </mat-select>
      </mat-form-field>
      <div class="interaction-wrapper">
        <app-tonal-button
          [counter]="selectedReports.size"
          buttonText="Löschen"
          (clicked)="deleteReports()"
          [dataTestId]="testIds.deleteButton"></app-tonal-button>
        <app-table-settings
          [allColumns]="displayedColumns"
          [displayedColumns]="columsToDisplay"
          [attr.data-testid]="testIds.tableSettingsComponent">
        </app-table-settings>
      </div>
    </div>
  </div>

  <app-generic-table
    [columnsToDisplay]="columsToDisplay"
    [dataSource]="(dataSource$ | async)!"
    [expandedTemplate]="expandedDetail"
    (pageChange)="onPageChange($event)"
    (sortChange)="onSortChange($event)"
    [totalItems]="total"
    [isLoading]="isLoading"
    (rowCheckboxClick)="getRowDetails($event)"
    [pageSize]="pageSize"
    [pageIndex]="pageIndex"
    [activeSortKey]="'received_ts'"></app-generic-table>
</div>

<ng-template #expandedDetail let-row>
  <h3 class="event-details">Event Details</h3>
  <div class="detail-container">
    <p [attr.data-testid]="testIds.reportedmessageEventid">{{ row.event_id }}</p>
    <p [attr.data-testid]="testIds.reportedmessageReason">{{ row.reason }}</p>
    <p [attr.data-testid]="testIds.reportedmessageBody">
      {{ row.event_json.content.body }}
    </p>
  </div>
  <div class="detail-footer">
    <p>Zeitstempel:</p>
    <p>
      {{ row.event_json.origin_server_ts | date: 'HH:mm:ss; dd.MM.yyyy' }}
    </p>
  </div>
</ng-template>
